// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2NAR7","errorLogs":"styles_errorLogs__2d4UR"};